'use strict';
const shadowRoots = new WeakMap;
exports.shadowRoots = shadowRoots;
